import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import { App } from '@capacitor/app';

/**
 * Verifica se está rodando em um dispositivo nativo (iOS/Android)
 */
export const isNativePlatform = () => Capacitor.isNativePlatform();

/**
 * Retorna a plataforma atual ('ios', 'android', ou 'web')
 */
export const getPlatform = () => Capacitor.getPlatform();

/**
 * Inicializa os plugins do Capacitor
 */
export const initializeCapacitor = async () => {
  if (!isNativePlatform()) {
    console.log('Running on web platform');
    return;
  }

  console.log(`Running on ${getPlatform()} platform`);

  try {
    // Configurar StatusBar
    await StatusBar.setStyle({ style: Style.Light });
    
    if (getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#ffffff' });
    }

    // Configurar listener do teclado
    Keyboard.addListener('keyboardWillShow', (info) => {
      document.body.style.setProperty('--keyboard-height', `${info.keyboardHeight}px`);
    });

    Keyboard.addListener('keyboardWillHide', () => {
      document.body.style.setProperty('--keyboard-height', '0px');
    });

    // Configurar listener do botão voltar (Android)
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });

    // Configurar listener de deep links
    App.addListener('appUrlOpen', (event) => {
      console.log('App opened with URL:', event.url);
      // Aqui você pode adicionar lógica para deep links
    });

    // Esconder splash screen após inicialização
    await SplashScreen.hide();

  } catch (error) {
    console.error('Error initializing Capacitor:', error);
  }
};

/**
 * Mostra o splash screen
 */
export const showSplash = async () => {
  if (isNativePlatform()) {
    await SplashScreen.show({
      autoHide: false,
    });
  }
};

/**
 * Esconde o splash screen
 */
export const hideSplash = async () => {
  if (isNativePlatform()) {
    await SplashScreen.hide();
  }
};
